// doctor-frontend/src/pages/chc/RadiologyDashboard.jsx
// Workbench for radiographers and imaging technicians in the CHC flow.
// This view lists all radiology orders (X‑ray, ultrasound, etc.) issued by
// the Medical Officer, allows the technician to capture images and submit
// reports, and marks orders as completed.

import React from 'react';
import { Box, Typography } from '@mui/material';

export default function RadiologyDashboard() {
  return (
    <Box p={2} className="min-h-screen">
      <Typography variant="h6" gutterBottom>
        Radiology Services
      </Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>
        View imaging orders from the Medical Officer, perform the study, upload
        the resulting images or reports, and mark the order as completed.
      </Typography>
      {/* Future enhancements: list of imaging requests, file uploader for
          radiographs/ultrasound images, reporting text fields. */}
    </Box>
  );
}